.chord {
  position: relative;
  display: inline-flex;
  padding: 1px 6px;
  margin: 2px 2px 4px;
  border-radius: 3px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  vertical-align: baseline;
  line-height: 1.2;
}

.chord--inScale {
  color: var(--tuna-notes-inScale);
  background: color-mix(in srgb, var(--tuna-notes-inScale) 8%, transparent);
}

.chord--outOfScale {
  color: var(--tuna-notes-outOfScale);
  background: color-mix(in srgb, var(--tuna-notes-outOfScale) 8%, transparent);
  /* Non-chromatic indicator (WCAG 2.2 SC 1.4.1 — color must not be the sole means
   * of conveying information). The dotted underline accompanies the color change
   * so color-blind users still get a signal that the chord is outside the key.
   * `text-decoration-color` uses the same out-of-scale token, so the underline
   * picks up theme changes and reads as part of the chord's identity.
   */
  text-decoration: underline dotted;
  text-decoration-color: var(--tuna-notes-outOfScale);
  text-decoration-thickness: 1px;
  text-underline-offset: 2px;
}

/* Match the editor-wide selection identity: same selection token used by native
 * ::selection and the block-level data-in-range bar. One color across text glyphs,
 * per-chord rectangles, and block bars so single-element and range selections read as
 * one consistent system. */
.chord--selected {
  background: var(--tuna-palette-selection);
}

.chord--clickable {
  text-decoration: underline;
}
